
import { FaceTecSDK } from "./../../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { Config } from "./../../../Config";


export const BmgThemeHelpers = (function () {
  const currentTheme = "FaceTec Theme";
  const themeResourceDirectory = "../../sample-app-resources/images/themes";
  const primaryColor = "#FA6300"; // laranja bmg
  const secondaryColor = "rgb(70, 42, 113)"; // roxo bmg
  const backgroundColor = "transparent"; // white
  const font = "'Source Sans Pro', Helvetica, sans-serif";
  const retryScreenSlideshowImages = [
    themeResourceDirectory + "FaceTec_ideal_1.png",
    themeResourceDirectory + "FaceTec_ideal_2.png",
    themeResourceDirectory + "FaceTec_ideal_3.png",
    themeResourceDirectory + "FaceTec_ideal_4.png",
    themeResourceDirectory + "FaceTec_ideal_5.png",
  ];

  function setAppTheme(theme) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    Config.currentCustomization = getCustomizationForTheme(theme);
    Config.currentLowLightCustomization = getLowLightCustomizationForTheme(theme);
    Config.currentDynamicDimmingCustomization = getDynamicDimmingCustomizationForTheme(theme);
    FaceTecSDK.setCustomization(Config.currentCustomization);
    FaceTecSDK.setLowLightCustomization(Config.currentLowLightCustomization);
    FaceTecSDK.setDynamicDimmingCustomization(Config.currentDynamicDimmingCustomization);
  }

  /**
   * Configuração padrão do tema
   * Aqui é configurado o SDK com as cores e fontes que serão utilizadas
   *
   */
  function getCustomizationForTheme(theme) {
    const currentCustomization = new FaceTecSDK.FaceTecCustomization();

    //Load Camera
    currentCustomization.initialLoadingAnimationCustomization.customAnimation = null;
    currentCustomization.initialLoadingAnimationCustomization.animationRelativeScale = 3.0;
    currentCustomization.initialLoadingAnimationCustomization.backgroundColor = backgroundColor;
    currentCustomization.initialLoadingAnimationCustomization.foregroundColor = primaryColor;

    //Tela Captura

    //Nao aparecer o botao de cancelar
    currentCustomization.cancelButtonCustomization.location = 0;

    //Borda
    currentCustomization.frameCustomization.borderColor = "none";
    currentCustomization.frameCustomization.borderWidth = "0px";

    //Header
    currentCustomization.guidanceCustomization.readyScreenHeaderFont = 16;
    currentCustomization.guidanceCustomization.readyScreenHeaderTextColor = "#37404E";

    //SubHeader
    currentCustomization.guidanceCustomization.readyScreenSubtextFont = 12;
    currentCustomization.guidanceCustomization.readyScreenSubtextTextColor = "#37404E";

    //Border Oval 
    currentCustomization.ovalCustomization.strokeColor = "#FA6300";
    currentCustomization.ovalCustomization.progressColor1 = "#FA6300";

    //Button
    currentCustomization.guidanceCustomization.buttonFont = "Montserrat";
    currentCustomization.guidanceCustomization.foregroundColor = "#FA6300";
    currentCustomization.guidanceCustomization.buttonBackgroundNormalColor = "#FA6300";
    currentCustomization.guidanceCustomization.buttonBackgroundHighlightColor = "#FA6300";
    currentCustomization.guidanceCustomization.buttonBackgroundDisabledColor = "#F9E2D4";



    currentCustomization.ocrConfirmationCustomization.buttonFont = "Montserrat";
    currentCustomization.ocrConfirmationCustomization.foregroundColor = "#FA6300";
    currentCustomization.ocrConfirmationCustomization.buttonBackgroundNormalColor = "#FA6300";
    currentCustomization.ocrConfirmationCustomization.buttonBackgroundHighlightColor = "#FA6300";
    currentCustomization.ocrConfirmationCustomization.buttonBackgroundDisabledColor = "#F9E2D4";

    // feedbackCustomization
    currentCustomization.feedbackCustomization.backgroundColor = "#FA6300";
    currentCustomization.ocrConfirmationCustomization.backgroundColors = "#FA6300";

   
     // Screen 
    currentCustomization.resultScreenCustomization.foregroundColor = "#FA6300";
    currentCustomization.resultScreenCustomization.resultAnimationForegroundColor = "#FA6300";
    currentCustomization.resultScreenCustomization.foregroundColor = "#FA6300";
    currentCustomization.resultScreenCustomization.activityIndicatorColor = "#FA6300";
    currentCustomization.resultScreenCustomization.resultAnimationBackgroundColor = "#FA6300";
    currentCustomization.resultScreenCustomization.uploadProgressFillColor = "#FA6300";
    currentCustomization.resultScreenCustomization.resultAnimationForegroundColor = "#FA6300";
    currentCustomization.resultScreenCustomization.messageFont = "Montserrat";


    //Logo
    currentCustomization.overlayCustomization.brandingImage = "src/assets/images/logo-bmg.png";
    return currentCustomization;


  }

  /**
   * Modo Pouca Luz
   * O SDK da FaceTec detecta quando o usuário está em uma situação de pouca luz e usa as APIs do dispositivo
   * para clarear a tela e faz a transição das cores FaceTec Frame e Outer Overlay para branco.
   * Isso iluminará adequadamente o rosto do usuário e melhorará a precisão e as taxas de sucesso.
   * */
  function getLowLightCustomizationForTheme(theme) {
    const currentLowLightCustomization = getCustomizationForTheme(theme);
    return currentLowLightCustomization;
  }

  /**
   * Modo Escurecimento Dinâmico
   * O SDK da FaceTec detecta quando o usuário está em uma situação de luz intensa e usa as APIs do dispositivo
   * para escurecer a tela e faz a transição das cores da moldura FaceTec e da sobreposição externa para preto.
   * Isso escurecerá adequadamente o rosto do usuário e melhorará a precisão e as taxas de sucesso.
   *
   */
  function getDynamicDimmingCustomizationForTheme(theme) {
    const currentDynamicDimmingCustomization = getCustomizationForTheme(theme);
    // OCR Confirmation Screen Customization
    currentDynamicDimmingCustomization.ocrConfirmationCustomization.sectionHeaderTextColor =
      "white";
    currentDynamicDimmingCustomization.ocrConfirmationCustomization.fieldLabelTextColor =
      "white";
    currentDynamicDimmingCustomization.ocrConfirmationCustomization.fieldValueTextColor =
      "white";
    currentDynamicDimmingCustomization.ocrConfirmationCustomization.inputFieldTextColor =
      "white";
    currentDynamicDimmingCustomization.ocrConfirmationCustomization.inputFieldPlaceholderTextColor =
      "rgba(0, 0, 0, 0.4)";
    currentDynamicDimmingCustomization.ocrConfirmationCustomization.inputFieldBorderColor =
      "white";

    currentDynamicDimmingCustomization.initialLoadingAnimationCustomization.customAnimation =
      null;
    currentDynamicDimmingCustomization.initialLoadingAnimationCustomization.animationRelativeScale = 1.0;
    currentDynamicDimmingCustomization.initialLoadingAnimationCustomization.backgroundColor =
      backgroundColor;
    currentDynamicDimmingCustomization.initialLoadingAnimationCustomization.foregroundColor =
      primaryColor;
    currentDynamicDimmingCustomization.initialLoadingAnimationCustomization.messageTextColor =
      primaryColor;
    currentDynamicDimmingCustomization.initialLoadingAnimationCustomization.messageFont =
      font;

    return currentDynamicDimmingCustomization;
  }

  function showNewTheme() {
    setAppTheme(currentTheme);
    updateThemeTransitionView();
  }

  function updateThemeTransitionView() {
    const transitionViewImage = "";
    const transitionViewTextColor =
      Config.currentCustomization.guidanceCustomization.foregroundColor;
    let transitionViewClass = "theme-transition-overlay__";
    let deviceType = "desktop";
    if (SampleAppUtilities.isLikelyMobileDevice()) {
      deviceType = "mobile";
    }

    transitionViewClass = "default";
    transitionViewClass += "__" + deviceType;
    document.getElementById("theme-transition-overlay-img").src =
      transitionViewImage;
    document.getElementById("theme-transition-overlay").className =
      transitionViewClass;
    document.getElementById("loading-session-token-text").style.color =
      transitionViewTextColor;
  }

  function getCurrentTheme() {
    return currentTheme;
  }

  return {
    getCurrentTheme: getCurrentTheme,
    themeResourceDirectory: themeResourceDirectory,
    setAppTheme: function (theme) {
      setAppTheme(theme);
    },
    showNewTheme: showNewTheme,
  };
})();
